// extracted by mini-css-extract-plugin
export default {"header":"OverviewHeader_header__JZzNL","title":"OverviewHeader_title__Bjva9"};